import { Injectable } from '@angular/core';
import { UUID } from '@macs-frontend/core/utils/uuid';

import { ApiService } from '@macs-frontend/core/services/api.service';
import { APIResponse, CPO } from '@macs-frontend/features/shared';
import { ListsUrls } from '@macs-frontend/core/utils/consts';
import { ProjectTaskAssignmentTimeslot } from '@macs-gql';
import { HttpClient } from '@angular/common/http';
import { createFormGroupState, FormGroupState } from 'ngrx-forms';

@Injectable({
  providedIn: 'root',
})
export class AssignmentTimeslotService extends ApiService {
  constructor(http: HttpClient) {
    super(http);
  }

  getUnconfirmedAssignmentTimeslots() {
    const req = {
      unconfirmed: true,
      own: true,
    };
    return this.http.get<APIResponse<ProjectTaskAssignmentTimeslot[]>>(
      `${this.API_PATH}/${ListsUrls.AssignmentTimeslots}?${this.stringify(req)}`,
    );
  }

  confirmTimeslot(
    timeslotId: UUID,
    args: {
      confirm: boolean;
      date: string | undefined;
      startTime: string | undefined;
    },
  ) {
    return this.http.patch<APIResponse<boolean>>(
      `${this.API_PATH}/${ListsUrls.AssignmentTimeslots}/${timeslotId}/set_confirm`,
      args,
    );
  }

  rejectTimeslot(timeslotId: UUID) {
    return this.http.patch<APIResponse<boolean>>(
      `${this.API_PATH}/${ListsUrls.AssignmentTimeslots}/${timeslotId}/reject`,
      {},
    );
  }
}
